module.exports = __webpack_public_path__ + "img/null-bg.76dcd1cf.png";